export type CommentReplyTarget = {
  id: string
  postId: string
  memberId: string
  authorName: string
  body: string
}

export function replyTargetForContext(target: CommentReplyTarget | null, postId: string, memberId: string): CommentReplyTarget | null {
  return target && target.postId === postId && target.memberId === memberId ? target : null
}

export function commentReplyInput(body: string, target: CommentReplyTarget | null, postId: string, memberId: string): { body: string; parentCommentId: string | null } {
  const trimmed = body.trim()
  if (!trimmed) throw new Error('Write a reply before sending.')
  if (target && !replyTargetForContext(target, postId, memberId)) throw new Error('The conversation or account changed. Choose who to reply to again.')
  return { body: trimmed, parentCommentId: target?.id ?? null }
}
